import { toEnglish } from '@/utils/string-helpers'

export function validateMultiLangNumbers(phoneNumber: string, pattern: RegExp): boolean {
    const normalizedNumber = toEnglish(phoneNumber)

    return pattern.test(normalizedNumber)
}
